import type { MailboxInfo } from 'owa-client-types';
import { isAccountFeatureEnabled } from 'owa-feature-flags';
import { isDraftAssistantFrontierEnabled } from './isDraftAssistantFrontierEnabled';

export function isDraftAssistantEnabled(mailboxInfo: MailboxInfo): boolean {
    return (
        isAccountFeatureEnabled('mon-copilot-draft-assistant', mailboxInfo) ||
        isDraftAssistantFrontierEnabled(mailboxInfo)
    );
}
